import { ContainerContext, defaultContainerContext } from "../../../context/container.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var ContainerProvider = function ContainerProvider(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? defaultContainerContext.containerAlign : _ref$align,
    children = _ref.children,
    maxWidth = _ref.maxWidth;
  var childContext = {
    containerAlign: align,
    containerMaxWidth: maxWidth || defaultContainerContext.containerMaxWidth
  };
  return /*#__PURE__*/_jsx(ContainerContext.Provider, {
    value: childContext,
    children: children
  });
};